import type {paths} from '../openapi/auth.swagger';
import {axiosInstance} from './axiosInstance';

type ConfirmOperation = paths['/executor_web/auth/confirm']['post'];

export type ConfirmLoginRequestBody = NonNullable<NonNullable<ConfirmOperation['requestBody']>['content']['application/json']>;
export interface ConfirmLoginRequest extends ConfirmLoginRequestBody {
	token: string;
}
export type ConfirmLoginResponse = ConfirmOperation['responses'][200]['content']['application/json'];
export type ConfirmLoginErrorResponse =
	| ConfirmOperation['responses'][400]['content']['application/json']
	| ConfirmOperation['responses'][401]['content']['application/json'];

/** POST `/executor_web/auth/confirm` — см. `paths['/executor_web/auth/confirm']` в auth swagger */
export function confirmLogin(request: ConfirmLoginRequest, signal?: AbortSignal) {
	const {token, ...body} = request;

	return axiosInstance.post<ConfirmLoginResponse>('auth/confirm', body, {
		signal,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
